import React from 'react';
import { formatCustomDateIsoString } from '../../../services/dateService';

export const nationalizationTimeColumns = [
  {
    field: "origin",
    header: "Origen",
    columnWidth: "120px"
  },
  {
    field: "orderNumber",
    header: "Nro de Orden",
    columnWidth: "150px"
  },
  {
    field: "provider",
    header: "Proveedor",
    columnWidth: "150px"
  },
  {
    field: "transportMode",
    header: "Modalidad de Transporte",
    columnWidth: "180px"
  },
  {
    field: "departureDateProvider",
    header: "Fecha salida Inst. proveedor",
    columnWidth: "200px",
    columnType: "custom",
    render: (rowData) => {
      const date = rowData.departureDateProvider;
      if (!date) return <div className="table-column-container"><p className="table-default-column">-</p></div>;
      return (
        <div className="table-column-container">
          <p className="table-default-column">{formatCustomDateIsoString(String(date))}</p>
        </div>
      );
    }
  },
  {
    field: "arrivalDateCustoms",
    header: "Fecha llegada a Aduana",
    columnWidth: "200px",
    columnType: "custom",
    render: (rowData) => {
      const date = rowData.arrivalDateCustoms;
      if (!date) return <div className="table-column-container"><p className="table-default-column">-</p></div>;
      return (
        <div className="table-column-container">
          <p className="table-default-column">{formatCustomDateIsoString(String(date))}</p>
        </div>
      );
    }
  },
  {
    field: "departureDateCustoms",
    header: "Fecha salida Aduana",
    columnWidth: "180px",
    columnType: "custom",
    render: (rowData) => {
      const date = rowData.departureDateCustoms;
      if (!date) return <div className="table-column-container"><p className="table-default-column">-</p></div>;
      return (
        <div className="table-column-container">
          <p className="table-default-column">{formatCustomDateIsoString(String(date))}</p>
        </div>
      );
    }
  },
  {
    field: "storeArrivalDate",
    header: "Fecha llegada a bodega",
    columnWidth: "180px",
    columnType: "custom",
    render: (rowData) => {
      const date = rowData.storeArrivalDate;
      if (!date) return <div className="table-column-container"><p className="table-default-column">-</p></div>;
      return (
        <div className="table-column-container">
          <p className="table-default-column">{formatCustomDateIsoString(String(date))}</p>
        </div>
      );
    }
  },
  {
    field: "transitTime",
    header: "Tiempo en tránsito",
    columnWidth: "140px",
    columnType: "custom",
    render: (rowData) => {
      return (
        <div className="table-column-container">
          <p className="table-default-column">{rowData.transitTime ?? '-'}</p>
        </div>
      );
    }
  },
  {
    field: "daysInCustoms",
    header: "Días en Aduana",
    columnWidth: "120px",
    columnType: "custom",
    render: (rowData) => {
      return (
        <div className="table-column-container">
          <p className="table-default-column">{rowData.daysInCustoms ?? '-'}</p>
        </div>
      );
    }
  },
  {
    field: "downloadDirect",
    header: "Descargue Directo",
    columnWidth: "140px",
    columnType: "custom",
    render: (rowData) => {
      const value = rowData.downloadDirect;
      const text = value === true || value === 1 ? 'Sí' : value === false || value === 0 ? 'No' : '-';
      return (
        <div className="table-column-container">
          <p className="table-default-column">{text}</p>
        </div>
      );
    }
  },
 
  {
    field: "actionButtons",
    header: "",
    columnType: "actionButtons",
    columnWidth: "120px"
  }
];
